import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

// axios 設定
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
// axios.defaults.baseURL = 'http://www.pddtvgame.com:8080/badarapi'  //baseurl(伺服器時用)
// axios.defaults.baseURL = 'http://192.168.2.209/badarapi'  //baseurl(伺服器時用)
// axios.defaults.baseURL = 'http://www.pddtvgame.com/badarapi'  //baseurl(伺服器時用)
axios.defaults.baseURL = 'http://www.corner-money.com/badarapi'  //baseurl(user伺服器時用)
// axios.defaults.baseURL = 'http://localhost/badarapi'  //baseurl(user伺服器時用)


//vue confirm的插件及設定
import VuetifyConfirm from 'vuetify-confirm'
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: '確認',
  buttonFalseText: '取消',
  color: 'error',
  icon: 'mdi-alert',
  title: '警告',
})

//跑馬燈效果
import MarqueeText from 'vue-marquee-text-component';
Vue.component('marquee-text', MarqueeText);


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
